import ChevronRight from "@mui/icons-material/ChevronRight";
import { Typography } from "@mui/material";
import { AnnouncementModal } from "components/ProductAnnouncement/AnnouncementModal";
import { SpotlightTour } from "components/ProductAnnouncement/SpotlightTour";

import processStagesIcon from "../../../../../assets/AnnouncementIcons/process-stages.png";
import { WasteStepperTourState } from "./useWasteStepperTour";
import { WASTE_STEPPER_TOUR_MODAL_COPY } from "./wasteStepperAnnouncementConfig";

type WasteStepperTourProps = Pick<
  WasteStepperTourState,
  | "steps"
  | "phase"
  | "isPending"
  | "dismissModal"
  | "softDismissModal"
  | "dontShowAgain"
  | "setDontShowAgain"
  | "startTour"
  | "dismissTour"
  | "completeTour"
  | "viewTourStep"
>;

/**
 * Renders this tour's own surfaces — the intro modal and, once started, the
 * driver.js walkthrough — once `useWasteStepperTour` says one is open. Split
 * out so the caller can also use its result for the "show me again" icon.
 */
export function WasteStepperTour({
  steps,
  phase,
  isPending,
  dismissModal,
  softDismissModal,
  dontShowAgain,
  setDontShowAgain,
  startTour,
  dismissTour,
  completeTour,
  viewTourStep,
}: WasteStepperTourProps) {
  return (
    <>
      <AnnouncementModal
        open={phase === "modal"}
        onDismiss={dismissModal}
        onSoftDismiss={softDismissModal}
        dontShowAgainLabel={isPending ? "Don't show me this again" : undefined}
        dontShowAgain={dontShowAgain}
        onDontShowAgainChange={setDontShowAgain}
        reopenHintText={isPending ? WASTE_STEPPER_TOUR_MODAL_COPY.reopenHint : undefined}
        titleId="waste-stepper-tour-announcement-title"
        dismissAriaLabel="Dismiss stepper tour announcement"
        hero={
          <img
            src={processStagesIcon}
            alt=""
            style={{ width: 56, height: 56, objectFit: "contain" }}
          />
        }
        title={WASTE_STEPPER_TOUR_MODAL_COPY.headline}
        subtitle={WASTE_STEPPER_TOUR_MODAL_COPY.subheadline}
        primaryCtaLabel={WASTE_STEPPER_TOUR_MODAL_COPY.primaryLabel}
        primaryCtaIcon={<ChevronRight />}
        onPrimaryCta={startTour}
      >
        <Typography variant="body1" color="text.primary">
          We&apos;ll walk through the steps on the left:{" "}
          <strong>why this filing is required</strong>, what Encamp is preparing,{" "}
          <strong>where to review and sign</strong>, and where to track filing status.
        </Typography>
      </AnnouncementModal>
      {phase === "tour" && steps ? (
        <SpotlightTour
          steps={steps}
          onDismiss={dismissTour}
          onComplete={completeTour}
          onStepViewed={viewTourStep}
        />
      ) : null}
    </>
  );
}
